import React from "react";
import { X, Flame, Leaf, AlertTriangle, Utensils } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { VegDot } from "@/components/common";

function Macro({ label, value, unit }) {
  return (
    <div className="bg-surface rounded-xl p-2.5 text-center">
      <div className="font-extrabold text-ink text-base">{value}{unit}</div>
      <div className="text-[10px] text-ink-600 uppercase tracking-wide">{label}</div>
    </div>
  );
}

export function FoodInfoDialog({ item, open, onClose }) {
  if (!item) return null;
  const n = item.nutrition;
  const hasData = !!n;
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-[440px] rounded-2xl p-0 overflow-hidden" data-testid="food-info-dialog">
        <DialogTitle className="sr-only">{item.name} information</DialogTitle>
        {item.image && <img src={item.image} alt={item.name} className="w-full h-36 object-cover" />}
        <button onClick={onClose} className="absolute top-3 right-3 w-8 h-8 bg-white rounded-full flex items-center justify-center shadow" data-testid="food-info-close"><X size={18} /></button>
        <div className="p-4">
          <div className="flex items-center gap-2">
            <VegDot veg={item.veg} />
            <h3 className="font-display font-bold text-lg text-ink">{item.name}</h3>
          </div>
          {item.healthy_score != null && (
            <div className="mt-2 inline-flex items-center gap-1.5 bg-emerald-50 text-veg font-bold text-xs px-2.5 py-1 rounded-full">
              <Leaf size={13} /> Healthy Score {item.healthy_score}/100
            </div>
          )}

          {hasData ? (
            <>
              <div className="grid grid-cols-5 gap-2 mt-4">
                <Macro label="Cal" value={n.calories} unit="" />
                <Macro label="Protein" value={n.protein} unit="g" />
                <Macro label="Carbs" value={n.carbs} unit="g" />
                <Macro label="Fat" value={n.fat} unit="g" />
                <Macro label="Fibre" value={n.fibre} unit="g" />
              </div>
              {item.cooking_method && (
                <div className="flex items-center gap-2 mt-4 text-sm text-ink"><Utensils size={15} className="text-coral" /> <span className="font-semibold">Cooking:</span> {item.cooking_method}</div>
              )}
              {item.spice_level && (
                <div className="flex items-center gap-2 mt-1.5 text-sm text-ink"><Flame size={15} className="text-coral" /> <span className="font-semibold">Spice:</span> {item.spice_level}</div>
              )}
              {item.ingredients && (
                <div className="mt-3"><div className="font-bold text-sm text-ink mb-0.5">Ingredients</div><p className="text-sm text-ink-600">{item.ingredients}</p></div>
              )}
              {item.allergens?.length > 0 && (
                <div className="mt-3 flex items-start gap-2 bg-amber-50 rounded-xl p-2.5">
                  <AlertTriangle size={15} className="text-amber-600 mt-0.5" />
                  <div><span className="font-bold text-sm text-amber-700">Allergens: </span><span className="text-sm text-amber-700">{item.allergens.join(", ")}</span></div>
                </div>
              )}
              {item.nutrition_source && <p className="text-[10px] text-ink-600 mt-3 italic">{item.nutrition_source}</p>}
            </>
          ) : (
            <p className="text-sm text-ink-600 mt-4">Nutrition information not provided by restaurant.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
